const entity = 'profile'
const entitySingle = 'profile'
const tableIcon = ''

export {
  entity,
  entitySingle,
  tableIcon
}
